import { ReactNode } from 'react';
import { Link } from 'react-router';
import { getAdminCatalogPath } from '../adminRoutes';

interface CatalogEntityHeaderProps {
  kind: 'products' | 'categories';
  title: string;
  subtitle: string;
  actions?: ReactNode;
  status?: ReactNode;
  isEditing?: boolean;
}

export function CatalogEntityHeader({ kind, title, subtitle, actions, status, isEditing = false }: CatalogEntityHeaderProps) {
  const listPath = getAdminCatalogPath(kind);
  const listLabel = kind === 'products' ? 'Товары' : 'Категории';
  return (
    <header className="catalog-entity-header">
      <div className="catalog-entity-header__toolbar">
        <nav aria-label="Путь в каталоге" className="catalog-breadcrumbs">
          <Link to={listPath}>{listLabel}</Link>
          <span aria-hidden="true">/</span>
          <span aria-current="page">{isEditing ? 'Редактирование' : 'Карточка'}</span>
        </nav>
        <div className="catalog-entity-header__actions">{actions}</div>
      </div>
      <div className="catalog-entity-header__identity">
        <div><p className="catalog-entity-header__meta">{subtitle}</p><h1>{title}</h1></div>
        {status}
      </div>
    </header>
  );
}
